import { lazy } from "react";
import { Route } from "react-router";
import EntityTargetScoreAssignment from "../EntityTargetScoreAssignment";
import { IcvList } from "../ICVs/IcvList";
import { IngredientReferenceList } from "../IngredientReferences/IngredientReferenceList";
import { QuestionnairesList } from "../Questionnaires/QuestionnairesList";
import { Questionnaire } from "../Questionnaires/Questionnaire";
import { DataListsValuesOverrides } from "../DataListsValuesOverrides/DataListsValuesOverrides";
import { SettingsRouteBoundary } from "./SettingsRouteBoundary";

const SettingsReferencesHomeLazy = lazy(() => import("../SettingsReferencesHome"));

export const referenceRoutes = () => (
    <>
        <Route
            path="references"
            element={
                <SettingsRouteBoundary>
                    <SettingsReferencesHomeLazy />
                </SettingsRouteBoundary>
            }
        />
        <Route path="references/ingredients" element={<IngredientReferenceList />} />
        <Route path="references/qss-versions">
            <Route index element={<QuestionnairesList />} />
            <Route path=":id" element={<Questionnaire />} />
        </Route>
        <Route path="references/custom-data-lists" element={<DataListsValuesOverrides />} />
        <Route path="references/sector-score-targets" element={<EntityTargetScoreAssignment />} />
        <Route path="references/icvs" element={<IcvList />} />
    </>
);
